module.exports = __webpack_public_path__ + "static/media/tutorial-image.9fda9358.jpg";